export default __webpack_public_path__ + "static/media/metro-lagoons.fcf6563b.svg";